var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-body"},[_c('title-bar',{attrs:{"title":"修改密码"}},[_c('el-button',{attrs:{"type":"default","icon":"fa fa-angle-left","loading":_vm.loading},on:{"click":function($event){return _vm.$router.back()}}},[_vm._v(" 返回 ")])],1),_c('modify-password-form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }